import { styled } from "@mui/material";

export const StyledDashboard = {
  CircularLoadingContainer: styled("div")({
    justifyContent: "center",
    marginTop: "230px",
    textAlign: "center",
  }),
  DashboardContainerStyled: styled("div")({
    backgroundColor: "#f5f6fa",
    padding: 20,
    height: "100%",
  }),
};

export const StyledDashboardContainer = {
  Title: styled("div")({
    flex: 1,
    height: "40px",
    margin: "13px",
    padding: "10px 10px 10px 20px",
    color: "#808080d1",
    backgroundColor: "#80808029",
    borderRadius: "1px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    fontSize: "17px",
  }),

  CardsContainer: styled("div")({
    backgroundColor: "#f5f6fa",
  }),
};
